
export const RATING_CHART_ID = '#chart-rating'